/**
 * RECENTLY VIEWED — small localStorage-backed helper. This is a real app
 * (not a Claude.ai artifact), so browser storage is the correct, standard
 * tool here — it just remembers which records this browser opened, purely
 * client-side, nothing sent anywhere.
 */
const KEY = 'ugarits_recently_viewed_v1';
const MAX = 8;

export interface RecentEntry {
  id: string;
  label: string;
  route: string;
  viewedAt: string;
}

export function getRecentlyViewed(): RecentEntry[] {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as RecentEntry[]) : [];
  } catch {
    return [];
  }
}

export function pushRecentlyViewed(entry: Omit<RecentEntry, 'viewedAt'>): void {
  try {
    const existing = getRecentlyViewed().filter((e) => e.id !== entry.id);
    const next = [{ ...entry, viewedAt: new Date().toISOString() }, ...existing].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // storage unavailable (private mode, etc) — silently no-op, never crash the app over this
  }
}
